import React from 'react'
import _ from 'lodash'
import {Buffer} from 'buffer'

import {Button, Icon, Input, Modal, Menu, Dropdown} from 'antd'

import {NotFound} from 'pages/NotFound.jsx'

import {MessageService} from 'api/message'

import {parse} from './parsing.js'
import {ConsoleOutput} from './ConsoleOutput.jsx'

const menu = setMode => (
   <Menu>
      <Menu.Item>
         <a onClick={() => setMode('ascii')}>ASCII</a>
      </Menu.Item>
      <Menu.Item>
         <a onClick={() => setMode('decimal')}>Decimal</a>
      </Menu.Item>
      <Menu.Item>
         <a onClick={() => setMode('hex')}>HEX</a>
      </Menu.Item>
   </Menu>
)

const ModeSelector = ({mode, setMode}) => (
   <Dropdown overlay={menu(setMode)} placement="topRight">
      <Button>
         Output Mode
         {mode ? ': ' + mode : null}
      </Button>
   </Dropdown>
)

ModeSelector.propTypes = {
   mode:    React.PropTypes.oneOf(['hex', 'decimal', 'ascii', null]),
   setMode: React.PropTypes.func.isRequired
}

const helpText = `
Online terminal emulator

This terminal enables you to communicate with the serial port of a
Tinymesh device. Each payload will be packed as a Tinymesh packet and
sent to the device. The terminal supports the following formats:

 1. "quoted string" - sends an ascii string
 2. [0, 1, 2, 3, 4] - sends a byte array each item is a decimal
 3. <01 ab cd ff>   - sends a byte array each item is a hex number
 4. "trigger" <0a>  - combination of any of the above

`

//
// Commands:
//   - help          - shows this text
//   - usage         - shows usage
//   - send \`data\`   - send data to device
//   - output \`mode\` - switch between output modes (hex, bytes, ascii)
//
// `

let usageText = `
usage: "string" | [ 1 10 100 255 ] | < 00 1a ff >, type help for more info

`

export class Console extends React.Component {
   static get propTypes() {
      return {
         device:   React.PropTypes.object,
         messages: React.PropTypes.array
      }
   }

   constructor() {
      super()

      this.state = {
         publishing: null,
         buffer:     '',
         tokens:     null,
         error:      null,
         mode:       'ascii'
      }

      this.handleInput = this.handleInput.bind(this)
      this.onSubmit = this.onSubmit.bind(this)
      this.onError = this.onError.bind(this)
      this.setMode = this.setMode.bind(this)
   }

   componentWillReceiveProps(next) {
      if (!_.eq(this.props.messages, next.messages)) {
         this.scrollElement(this._console)
      }
   }

   scrollElement(ref) {
      window.requestAnimationFrame(() => {
         if (!ref) {
            return
         }

         ref.scrollTop = ref.scrollHeight
      })
   }

   handleSend(buffer) {
      let {key, network} = this.props.device,
         command = {
            'proto/tm': {
               type:       'command',
               command:    'serial',
               data:       buffer.toString('base64'),
               cmd_number: Math.floor(Math.random() * 1000 % 128)
            }
         }

      this.setState({publishing: true})

      return MessageService.write(network, key, command, false)
         .then(_resp => this.setState({publishing: false, buffer: ''}))
         .catch(error => {
            this.onError(error)
            this.setState({publishing: false})
         })
   }

   commands() {
      return {
         usage: () => usageText,
         help:  () => helpText,

         send: input => {
            let res = parse(input, 0)

            if (Buffer.isBuffer(res)) {
               this.handleSend(res)

               return null
            } else {
               return res
            }
            // return Buffer.isBuffer(res) ? this.sendData(res, p) : res
         },

         output: function(mode) {
            if ('hex' === mode || 'ascii' === mode || 'bytes' === mode) {
               return {
                  info:  'Switched from `' + this.state.mode + '` to `' + mode + '`',
                  state: {mode}
               }
            }

            return {
               error: 'Invalid output mode: `' + mode + '`\nusage: output <hex | ascii | bytes>'
            }
         }
      }
   }

   handleInput(ev) {
      let buffer = ev.target.value

      let head = buffer.split(/\s/, 1),
         rest = head[0] !== buffer ? buffer.substr(head[0].length + 1) : buffer

      if (this.commands()[head]) {
         this.setState({buffer: buffer, tokens: this.commands()[head](rest, 0)})
      } else {
         // check if it's directly data or just a miss-spelled command
         this.setState({buffer: buffer, tokens: null})
      }
   }

   onSubmit(ev) {
      ev.preventDefault()

      let {buffer} = this.state,
         result = this.commands().send(buffer)

      if (result) {
         if (result.error) {
            this.onError(result.error)
         } else {
            this.onError('Unexpected result from action: ' + JSON.stringify(result.error))
         }
      } else {
         this.setState({
            buffer: buffer
         })
      }
   }

   onError(error) {
      let msg

      if (error.data) {
         msg = error.data.error || error.data.message || error.toString()
      } else if (_.isError(error)) {
         msg = error.toString()
      } else {
         msg = error.toString()
      }

      Modal.error({
         title:   'Failed to publish message',
         content: msg
      })
   }

   setMode(mode) {
      this.setState({mode: mode})
   }

   render() {
      const {publishing, buffer, tokens, mode} = this.state,
         {device} = this.props

      if (!device) {
         return <NotFound />
      }

      return (
         <div className="console">
            <pre
               className="output"
               ref={ref => {
                  this._console = ref
               }}
            >
               <ConsoleOutput {...this.props} mode={mode} header={helpText} />
            </pre>
            <div>
               <form onSubmit={this.onSubmit}>
                  <div>
                     <Input
                        type="text"
                        value={buffer}
                        disabled={publishing}
                        prefix={<Icon type="ellipsis" />}
                        suffix={
                           <div>
                              <ModeSelector mode={mode} setMode={this.setMode} />
                              <Button
                                 icon="arrow-down"
                                 type="primary"
                                 onClick={this.onSubmit}
                                 loading={publishing}
                              >
                                 Send Data
                              </Button>
                           </div>
                        }
                        onChange={this.handleInput}
                        className="input form-control"
                     />
                  </div>

               </form>
            </div>
         </div>
      )
   }
}



// WEBPACK FOOTER //
// lib/bundle/dashboard/device/console/index.jsx